import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgBackiOs({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.414 12l8.295-8.293a1 1 0 10-1.414-1.414l-9.002 9a.997.997 0 000 1.414l9.002 9a1 1 0 101.414-1.414L4.414 12z"
        fill={color}
      />
    </svg>
  )
}

export default SvgBackiOs
